export default __webpack_public_path__ + "media/images/mailer/icon_grade-3b3ef2433a8f6aa6251a4c99aad434d7.png";